import {
  Dropdown,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {ScrollView} from 'native-base';
import React from 'react';
import {useWindowDimensions} from 'react-native';

import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

import {MonthObj} from './months';

export interface MonthDropdownProps {
  onSelect: (month: MonthObj) => void;
  selected: MonthObj | undefined;
  months: MonthObj[];
}

const MonthDropdown = (props: MonthDropdownProps) => {
  const {onSelect, selected, months} = props;
  const {height} = useWindowDimensions();
  const isDesktop = useIsDesktop();
  const dropdownMaxHeight = isDesktop ? `${height / 2}px` : `${height / 4}px`;
  const {trackAdobeEvent} = useTrackEvent();

  const items = months.map(({name, key}) => (
    <Dropdown.Item
      key={`month-dropdown-${key}`}
      onPress={() => onSelect({key, name})}>
      {name}
    </Dropdown.Item>
  ));

  return (
    <Dropdown
      onOpen={() =>
        trackAdobeEvent({
          event: AdobeEvent.click,
          click: {
            name: 'my account rewards history month',
          },
        })
      }
      label="Month"
      error=""
      value={selected?.name}>
      <ScrollView maxHeight={dropdownMaxHeight}>{items}</ScrollView>
    </Dropdown>
  );
};

export default MonthDropdown;
